module.exports = __webpack_public_path__ + "img/img-1-desk.e848fe6f.jpg";